<template>
  <div class="l-contact-container">
    <div class="c-navbars">
      <!-- <div class="c-navbar">
        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=85972337&site=qq&menu=yes"><img border="0" src="../../../common/image/qq.jpg" alt="点击这里给我发消息" title="点击这里给我发消息"/></a>
      </div> -->
      <div class="c-navbar__wx">
        <img
          class="c-wx__img"
          src="../../../common/image/qrcode.png"
          alt=""
          srcset=""
        />
        <div class="c-navbar">
          <img src="../../../common/image/wechat.png" alt="" srcset="" />
        </div>
      </div>
      <div class="c-navbar__inline">
        <div class="c-navbar__detail">19921048820</div>
        <div class="c-navbar">
          <img src="../../../common/image/dianhua.jpg" alt="" srcset="" />
        </div>
      </div>
      <div class="c-navbar" @click="scrollTo">
        <img src="../../../common/image/top.jpg" alt="" srcset="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentTab: 'Index'
    };
  },
  computed: {},
  methods: {
    scrollTo() {
      window.scrollTo(0, 0);
    },
    go(routerName) {
      this.$router.push({ name: routerName });
    }
  }
};
</script>
<style lang="scss">
@import '~common/scss/mixin';
.l-contact-container {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 999;
  .c-navbars {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: flex-end;
  }
  .c-navbar__inline {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .c-navbar__detail {
      background: rgba(51, 134, 255, 1);
      padding: 0 20px;
      font-size: 16px;
      font-weight: 400;
      height: 50px;
      line-height: 50px;
      color: rgba(255, 255, 255, 1);
      opacity: 0;
      transform: translate3d(20px, 0, 0);
      transition: all 0.3s linear;
    }
    &:hover {
      .c-navbar__detail {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        transition: all 0.3s linear;
      }
    }
  }
  .c-navbar__wx {
    position: relative;
    .c-wx__img {
      position: absolute;
      top: 50%;
      left: -70px;
      width: 70px;
      opacity: 0;
      transform: translateY(-50%);
      transition: all 0.3s linear;
    }
    &:hover {
      .c-wx__img {
        opacity: 1;
        transition: all 0.3s linear;
      }
    }
  }
  .c-navbar {
    cursor: pointer;
    background: rgba(51, 134, 255, 1);
    width: 50px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .c-navbar--active {
    color: rgba(255, 255, 255, 1);
  }
}
</style>
